import React from 'react';
import { Link } from 'react-router';
import { ArrowLeft, Settings } from 'lucide-react';

const ModuleHeader = ({ title, eyebrow, icon: Icon, tone = 'plum', actions }) => (
    <header className={`module-header module-header-${tone}`}>
        <div className="module-header-inner">
            <Link to="/" className="module-header-back" aria-label="Back to today">
                <ArrowLeft size={20} />
                <span>Today</span>
            </Link>

            <div className="module-header-title">
                {Icon && <span className="module-header-icon"><Icon size={19} /></span>}
                <span>
                    {eyebrow && <small>{eyebrow}</small>}
                    <strong>{title}</strong>
                </span>
            </div>

            <div className="module-header-actions">
                {actions}
                <Link to="/settings" className="module-header-settings" aria-label="Open settings">
                    <Settings size={19} />
                </Link>
            </div>
        </div>
    </header>
);

export default ModuleHeader;
